/* eslint-disable @reatom/unit-naming-rule */
import { PoolEvent } from '@blade/blockchain-types'
import { Result } from '@blade/std-lib'
import {
  fetchNewPairsRequestAction,
  pairRegistry,
  reatomPair,
} from '@root/entities/pair/atoms'

import { ExploreFilter } from '../model'
import { EXPLORE_LIST_PERIOD_MAP } from '../model/constants'
import { ExploreFeedType } from '../model/explore-feed-type'

import { reatomPairEventsCommon } from './reatom-explore-events'
import { newExploreFiltersAtom } from './reatom-explore-filters'

const reatomExploreNewPairs = () => {
  const pairsStateAtom = reatomPairEventsCommon({
    event: PoolEvent.New,
    filter: newExploreFiltersAtom,
    period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.New],
    /**
     * Newest first, by when the pool was created.
     *
     * The column had no order at all and stood in whatever order things
     * arrived. Arrival is not age: a launch reaches us before its row is
     * readable and is retried for up to four seconds, so a pool created nine
     * seconds ago could land after one created three seconds ago and sit
     * above it. The list is called New Pairs; it should read like it.
     */
    compare: () => reatomPair.cmpByCreatedAtDesc,
    loadItems: async (ctx, { limit, filter, network, period }) => {
      const result = await ctx.schedule(() =>
        fetchNewPairsRequestAction(ctx, {
          filters: filter
            ? ExploreFilter.toPoolFiltersDto(filter, undefined, period)
            : undefined,
          limit,
          network,
          cursor: undefined,
        }),
      )
      return result.pipe(
        Result.map((it) =>
          it.data.map((dto) => pairRegistry.resolveFromDto(ctx, dto)),
        ),
      )
    },
  })

  return pairsStateAtom
}

export type ExploreNewPairsModel = ReturnType<typeof reatomExploreNewPairs>
export const exploreNewPairsModel = reatomExploreNewPairs()
